<template>
<div id="faq" class="fixed-content">
  <page-section title="Foire aux questions">
    <div class="row" v-if="!isReady">
      <div class="col-xs-12 text-center">
        <h4>
          <sui-loading-text>Chargement des questions</sui-loading-text>
        </h4>
      </div>
    </div>
    <div class="container-cap" v-else>
      <textarea class="form-control editor" rows="1"
                v-model.trim="currentFilter"
                placeholder="Rechercher..."
                @keydown.enter.exact.prevent>
      </textarea>
      <hr />
      <div v-for="cat in list"
           :key="`category-${cat.key}`">
        <h3 role="button" class="category-title" @click="toggle(cat.key)">
          <span class="glyphicon glyphicon-plus" v-if="!collapse[cat.key]"
                aria-hidden="true">
          </span>
          <span class="glyphicon glyphicon-minus" v-else
                aria-hidden="true">
          </span>
          {{ cat.title }}
        </h3>
        <hr>
        <div class="row">
          <div class="col-lg-10 col-xs-12">
            <collapse v-model="collapse[cat.key]" class="qa">
              <div v-for="qa in cat.qas"
                   :key="`qa-${cat.key}-${qa.key}`">
                <h4 role="button" @click="toggle(qa.key)">
                  <span class="glyphicon glyphicon-plus"
                        v-if="!collapse[qa.key]"
                        aria-hidden="true">
                  </span>
                  <span class="glyphicon glyphicon-minus" v-else
                        aria-hidden="true">
                  </span>
                  <span v-html="qa.q.join(' ')"></span>
                </h4>
                <collapse v-model="collapse[qa.key]">
                  <p class="text-justify" v-html="qa.a.join(' ')"></p>
                </collapse>
                <hr>
              </div>
            </collapse>
          </div>
        </div>
      </div>
    </div>
  </page-section>
</div>
</template>
<script>
import pageSection from '@/components/pagesection'
import suiLoadingText from '@/sui/components/loadingtext'
import { mapState } from 'vuex'

import filter from '@/sui/tools/filter'

export default {
  name: 'faq',

  data: function () {
    return {
      currentFilter: '',
      collapse: null,
      isReady: false
    }
  },

  mounted: function () {
    const collapse = {}
    this.faq.forEach(
      cat => {
        collapse[cat.key] = false
        cat.qas.forEach(
          (qa, j) => {
            collapse[`${cat.key}-${j}`] = false
          }
        )
      }
    )
    this.collapse = collapse
    this.isReady = true
  },

  computed: {
    ...mapState({
      faq: state => state.cloud.cfg.faq
    }),

    filterTest: function () {
      if (this.currentFilter === '') {
        return null
      }

      return filter.build({}, this.currentFilter)
    },

    list: function () {
      const expr = (this.filterTest != null && this.filterTest.error == null)
        ? this.filterTest : () => true
      const reducer = (result, s) => {
        const qas = []
        s.qas.forEach(
          (qa, i) => {
            if (expr({ filterlabel: qa.q }) ||
                expr({ filterlabel: qa.a })) {
              qas.push(
                {
                  q: qa.q,
                  a: qa.a,
                  key: `${s.key}-${i}`
                }
              )
            }
          }
        )
        if (qas.length > 0) {
          result.push(
            {
              title: s.title,
              qas: qas,
              key: s.key
            }
          )
        }
        return result
      }
      return this.faq.reduce(reducer, [])
    }
  },

  methods: {
    toggle: function (key) {
      this.collapse[key] = !this.collapse[key]
    }
  },

  components: {
    pageSection,
    suiLoadingText
  }
}
</script>
<style scoped lang="less">
#faq {
  min-height: 80rem;

  .editor-feedback {
    padding: 0.3rem;
  }

  .editor {
    resize: none;
    white-space: nowrap;
    padding: 0.7rem;
    padding-bottom: 0rem;
    overflow-x: auto;
    width: 100%;
    resize: none;
  }

  .qa {
    padding-left: 6rem;
    font-size: 110%;

    .glyphicon {
      margin-left: -3rem;
    }
  }

  .glyphicon {
    margin-right: 1rem;
  }

  .category-title {
    text-align: left;
  }
}
</style>
